import React from 'react';
import TableTop from '../../../../core/table/TableTop';
import TableBody from '../../../../core/table/TableBody';
import TablePaging from '../../../../core/table/TablePaging';
import SaveToExcelButton from '../../../../core/table/actions/SaveToExcelButton';
import HelpButton from '../../../../core/components/HelpButton';
import TableHead from '../../../../core/table/TableHead';
import { HttpErrorIgnore } from '../../../../../global';

// provider imports
import { useProviderListTableInit } from './useProviderListTableInit';
import { useProviderListTableState } from './useProviderListTableState';
import { useProviderListStore } from '../pagehooks/useProviderListStore';
import { useProviderData } from './useProviderData';
import providerRepo from '../../data/providerRepo';
import TableExceedsDataSizeMessage from '../../../../core/table/TableExceedsDataSizeMessage';
import TableList from '../../../../core/table/TableList';

const providerListTableId = 'adminProviderList';

const ProviderListTable = (): JSX.Element => {
    const init = useProviderListTableInit();
    if (init) {
        return <></>;
    }

    return <TableWrapper />;
};

const onGetExcel = (): Promise<HttpErrorIgnore | undefined> => providerRepo.getExcel();

const TableWrapper = (): JSX.Element => {
    const { action, loading, routeToEdit, showHelp } = useProviderListStore();
    const { fltStats, paging, cols, sections, sort, filters, setFilter, setSort, setPaging, waiting, setWait } =
        useProviderListTableState();
    const { items, rawDataSize } = useProviderData();

    // don't show table
    if (action !== 'LIST' || loading) {
        return <></>;
    }

    const handleHelpLinkClick = (): void => {
        showHelp();
    };

    return (
        <TableList>
            <TableExceedsDataSizeMessage dataSize={rawDataSize} />
            <TableTop
                id={providerListTableId}
                fltStats={fltStats}
                topRight={
                    <div>
                        <SaveToExcelButton
                            waiting={waiting}
                            setWait={setWait}
                            onGetExcel={onGetExcel}
                        />
                        <HelpButton onClick={handleHelpLinkClick} />
                    </div>
                }
            />
            <table>
                <TableHead
                    cols={cols}
                    sections={sections}
                    sort={sort}
                    filters={filters}
                    setFilter={setFilter}
                    setSort={setSort}
                />
                <TableBody
                    cols={cols}
                    rows={items}
                    onClick={routeToEdit}
                />
            </table>
            <TablePaging
                paging={paging}
                setPaging={setPaging}
                fltStats={fltStats}
            />
        </TableList>
    );
};

export default ProviderListTable;
